var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-actions',{staticClass:"justify-center"},[_c('v-btn',{staticClass:"mb-2",attrs:{"dark":"","color":"primary"},on:{"click":function($event){return _vm.onClick(_vm.params)}}},[_vm._v("\r\n    "+_vm._s(_vm.buttonText)+"\r\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }